import type { Format } from '../schemas/format';

/**
 * Public Forum, NSDA standard times. VERIFY against the current NSDA High School Unified Manual.
 */
export const PF_NSDA: Format = {
  id: 'pf-nsda',
  version: 1,
  name: 'Public Forum (NSDA)',
  event: 'pf',
  ruleset: 'NSDA',
  extensionNote: 'In PF an argument only counts if its team extended it in both Summary and Final Focus.',
  sideLabels: ['Pro', 'Con'],
  teamSize: 2,
  order: 'coinFlip',
  prepSec: 180,
  graceSec: 10,
  points: { min: 25, max: 30, step: 0.1 },
  extensionRoles: ['summary', 'final'],
  segments: [
    { id: 'C1', kind: 'speech', role: 'constructive', label: 'Constructive', short: 'C', durationSec: 240, by: 'first', speakers: [1] },
    { id: 'C2', kind: 'speech', role: 'constructive', label: 'Constructive', short: 'C', durationSec: 240, by: 'second', speakers: [1] },
    { id: 'CF1', kind: 'questioning', role: 'questioning', label: 'Crossfire', short: 'CF', durationSec: 180, by: 'both', speakers: [1] },
    { id: 'R1', kind: 'speech', role: 'rebuttal', label: 'Rebuttal', short: 'R', durationSec: 240, by: 'first', speakers: [2] },
    { id: 'R2', kind: 'speech', role: 'rebuttal', label: 'Rebuttal', short: 'R', durationSec: 240, by: 'second', speakers: [2] },
    { id: 'CF2', kind: 'questioning', role: 'questioning', label: 'Crossfire', short: 'CF', durationSec: 180, by: 'both', speakers: [2] },
    { id: 'S1', kind: 'speech', role: 'summary', label: 'Summary', short: 'S', durationSec: 180, by: 'first', speakers: [1] },
    { id: 'S2', kind: 'speech', role: 'summary', label: 'Summary', short: 'S', durationSec: 180, by: 'second', speakers: [1] },
    { id: 'GCF', kind: 'questioning', role: 'questioning', label: 'Grand Crossfire', short: 'GCF', durationSec: 180, by: 'both', speakers: [1, 2] },
    { id: 'FF1', kind: 'speech', role: 'final', label: 'Final Focus', short: 'FF', durationSec: 120, by: 'first', speakers: [2] },
    { id: 'FF2', kind: 'speech', role: 'final', label: 'Final Focus', short: 'FF', durationSec: 120, by: 'second', speakers: [2] },
  ],
  sheets: [
    { id: 'case-first', title: '{first} case', owner: 'first', segmentIds: ['C1', 'CF1', 'R1', 'R2', 'CF2', 'S1', 'S2', 'GCF', 'FF1', 'FF2'] },
    { id: 'case-second', title: '{second} case', owner: 'second', segmentIds: ['C2', 'CF1', 'R1', 'R2', 'CF2', 'S1', 'S2', 'GCF', 'FF1', 'FF2'] },
  ],
};

/**
 * Public Forum under CHSSA rules (Article XI §5): the same speeches, times, speakers and 3 minutes of prep as NSDA,
 * with a coin flip for side and speaking position.
 */
export const PF_CHSSA: Format = { ...PF_NSDA, id: 'pf-chssa', name: 'Public Forum (CHSSA)', ruleset: 'CHSSA' };
